import { NgClass, NgIf } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lx-selector-field-container',
  templateUrl: './selector-field-container.component.html',
  styleUrls: ['./selector-field-container.component.scss'],
  imports: [NgIf, NgClass],
})
export class SelectorFieldContainerComponent {
  label = input<string | undefined>();
  disabled = input<boolean>(false);
  empty = input<boolean>(true);

  /**
   * Handler for click event when the user clicks on the selector field control
   */
  selectorFieldHandler = input.required<() => void>();
}
